import useAuth from '@/api/auth';
import router from '@/router';
const auth = useAuth();

export const AUTH_NSPACE = 'auth';
export const LOCALSTORAGE_ACCESS_TOKEN = 'accessToken';

export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_LOGOUT = 'SET_LOGOUT';

export default {
  namespaced: true,

  state: {
    accessToken: localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN)
  },
  mutations: {
    [SET_ACCESS_TOKEN](state, token) {
      state.accessToken = token;
    },
    [SET_LOGOUT](state) {
      state.accessToken = null;
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const { data } = await auth.login(credentials);
      if (!data.authenticate.jwtToken) {
        throw new Error('User does not exist');
      } else {
        commit(SET_ACCESS_TOKEN, data.authenticate.jwtToken);
        router.push({ name: 'root' });
      }
    },
    async logout({ commit }) {
      commit(SET_LOGOUT);
      router.push({ name: 'login' });
    }
  }
};
